import { HeartBank } from "../../../managers/HeartBank";
import { Crypto } from "../../../models/Crypto.ts";
import template from "./hb-tabbar.mjs";
import { HbHeader } from "../../hb-header/hb-header.ts";
import { HbMain } from "../../hb-main/hb-main";

import { render } from "lit-html";
import { Drawer } from "flowbite";
import type { DrawerOptions, DrawerInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

export class HbTabBar extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private crypto: Crypto = new Crypto();

    private drawer: DrawerInterface;
    private header = document.querySelector("hb-header") as HbHeader;
    private main = document.querySelector("hb-main") as HbMain;
    private tabBar: HTMLElement;

    private mint: HTMLElement;
    private mine: HTMLElement;
    private aquarius: HTMLElement;

    private light: HTMLElement;
    private dark: HTMLElement;
    private auto: HTMLElement;

    constructor() {
        super();
        render(template(null), this);

        this.tabBar = this.querySelector("#hb-tabbar")!;
        this.mint = this.querySelector("#hb-chest-mint")!;
        this.mine = this.querySelector("#hb-chest-mine")!;
        this.aquarius = this.querySelector("#hb-chest-aquarius")!;

        this.light = this.querySelector("#hb-light-mode")!;
        this.dark = this.querySelector("#hb-dark-mode")!;
        this.auto = this.querySelector("#hb-auto-mode")!;

        const options: DrawerOptions = {
            placement: "bottom",
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: "bottom-[70px]", // doesn't work
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
            onHide: () => {
                this.tabBar.classList.replace("bottom-0", "bottom-[70px]");
            },
            onShow: () => {
                this.tabBar.classList.replace("bottom-[70px]", "bottom-0");
            },
            onToggle: () => {}
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-tabbar",
            override: true
        };

        this.drawer = new Drawer(this.tabBar, options, instanceOptions);
    }

    connectedCallback() {
        this.render();
        this.addChestListeners();
        this.addColorSchemeListeners();

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);

            // doesn't work bc flowbite only initiates on page load
            // this.mint.dataset.modalShow = this.heartbank.user
            //     ? "hb-ship"
            //     : "hb-jewel";
        });
    }

    show() {
        this.classList.remove("hidden");
    }

    hide() {
        this.classList.add("hidden");
    }

    private render() {
        switch (localStorage.colorScheme) {
            case "dark":
                document.documentElement.classList.add("dark");
                break;
            case "light":
                document.documentElement.classList.remove("dark");
                break;
            default:
                if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
                    document.documentElement.classList.add("dark");
                } else {
                    document.documentElement.classList.remove("dark");
                }
        }
    }

    private addChestListeners() {
        this.mint.addEventListener("click", async () => {
            this.main.hideShip();
            this.main.hideJewel();

            const trustkeysCount = await this.crypto.count();
            const heartkeysCount = parseInt(
                localStorage.getItem("heartkeysCount") || "0"
            );

            if (this.heartbank.user) {
                if (heartkeysCount || trustkeysCount) {
                    this.main.showShip();
                    window.location.hash = "#/mint/ship";
                } else if (
                    confirm(
                        "A Safe is required to mint HeartBank® Chests with Proof of Humanity ℠\n\nWould you like to create one now?"
                    )
                ) {
                    this.header.showSafe();
                    localStorage.setItem(
                        "redirect-safes",
                        window.location.hash
                    );
                    window.location.hash = "#/safes"; // can refactor to trustkey if better
                }
            } else {
                if (trustkeysCount) {
                    this.main.showShip();
                    window.location.hash = "#/mint/ship";
                    // this.main.showJewel();
                    // window.location.hash = "#/mint/jewel";
                } else if (
                    confirm(
                        "A Locker is required to mint HeartBank® Chests.\n\nWould you like to create one now?"
                    )
                ) {
                    this.header.showLocker();
                    localStorage.setItem(
                        "redirect-lockers",
                        window.location.hash
                    );
                    window.location.hash = "#/lockers";
                }
            }
        });

        this.mine.addEventListener(
            "click",
            () => (window.location.hash = "#/mine")
        );

        this.aquarius.addEventListener(
            "click",
            () => (window.location.hash = "#/aquarius")
        );
    }

    private addColorSchemeListeners() {
        window
            .matchMedia("(prefers-color-scheme: dark)")
            .addEventListener("change", (event: MediaQueryListEvent) => {
                this.render();
                //logEvent(analytics, "color", { scheme: "dark" });
            });

        this.light.addEventListener("click", (event: Event) => {
            localStorage.setItem("colorScheme", "light");
            this.render();
            this.drawer.hide();
        });

        this.dark.addEventListener("click", (event: Event) => {
            localStorage.setItem("colorScheme", "dark");
            this.render();
            this.drawer.hide();
        });

        this.auto.addEventListener("click", (event: Event) => {
            localStorage.setItem("colorScheme", "system");
            this.render();
            this.drawer.hide();
        });
    }
}
